import { MenuAction, MenuState } from "../store/types/types";
import modules from "../mockData/modules.json";
import IDrawerMenus from "../interfaces/IDrawerMenus";

const mapSubModules = (
  subs: any[],
): import("../interfaces/IDrawerSubMenus").default[] => {
  return subs.map((sub) => {
    return {
      id: sub.Key,
      label: sub.Label,
      resourceKey: sub.ResourceKey,
      icon: sub.Icon,
      route: sub.Route,
      SubModules: sub.SubModules ? mapSubModules(sub.SubModules) : [],
    };
  });
};

// Mantém a paridade com store/reducer.ts (fonte real do menu lateral): exibe
// todos os menus, menos os ResourceKeys escondidos.
const HIDDEN_MENU_RESOURCE_KEYS = ["signout"];

const INITIAL_STATE = {
  menus: modules
    .filter((module) => !HIDDEN_MENU_RESOURCE_KEYS.includes(module.ResourceKey))
    .map((module) => {
    const response: IDrawerMenus = {
      id: module.Id,
      label: module.Name,
      resourcekey: module.ResourceKey,
      icon: module.Icons,
      route: module.Route,
      isOpen: false,
      SubModules: module.SubModules ? mapSubModules(module.SubModules) : [],
    };

    return response;
  }),

  // menus: modules.map((module) => {
  //     let subModules= module.SubModules?.map((sub) => {
  //       return {
  //         id: sub.Key,
  //           label: sub.Label,
  //           resourcekey: sub.ResourceKey,
  //           icon: sub.Icon,
  //           route: sub.Route
  //       };
  //     });

  //     let response: IDrawerMenus = {
  //       id: module.Id,
  //       label: module.Name,
  //       resourcekey: module.ResourceKey,
  //       icon: module.Icons,
  //       subModules: subModules,
  //       route: module.Route,
  //       isOpen: false,
  //     };

  //     return response;
  //   })
};

// eslint-disable-next-line
export default function menuReducer(state: MenuState, action: MenuAction) {
  if (typeof state === "undefined") {
    return INITIAL_STATE;
  }

  switch (action.type) {
    case "SET_MENU": {
      return {
        ...state,
        menus: action.value,
      };
    }
    default:
      return state;
  }
}
